import fetch from '@/api/fetch'
/**获取通知公告树 */
export const getNoticeList=params => fetch.post('/notice/query/list',params)
/**发布公告信息 */
export const releaseNoticeList=params => fetch.post('/notice/release',params)
/**删除公告 */
export const deleteNoticeList=id => fetch.delete(`/notice/delete/${id}`)
/**查询 */
export const queryNotice=id => fetch.post(`/notice/editor/${id}`)
/**发布取消 */
export const releaseAndcancelNotice=params => fetch.post('/notice/releaseAndcancel',params)
